import React from 'react';

const Logo = ({ size = 80 }) => {
  return (
    <img
      src="/logo.png"
      alt="Easy Money Logo"
      style={{
        height: `${size}px`,
        width: 'auto',
        display: 'inline-block',
        verticalAlign: 'middle'
      }}
      onError={(e) => {
        // Fallback if image doesn't exist
        e.target.style.display = 'none';
      }}
    />
  );
};

export default Logo;

